export class TokenRegistry {
    #sessionToken: string;

    #sessionRefreshToken?: string;

    get sessionToken(): string {
        return this.#sessionToken;
    }

    set sessionToken(token: string) {
        this.#sessionToken = token;
    }

    get sessionRefreshToken(): string | undefined {
        return this.#sessionRefreshToken;
    }

    set sessionRefreshToken(refreshToken) {
        this.#sessionRefreshToken = refreshToken;
    }
}
